module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.containerClasses,
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    attrs: {
      "id": "top-header"
    }
  }, [_c('nav', {
    staticClass: "inner"
  }, [_c('h1', {
    attrs: {
      "id": "site-logo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": '/home'
    }
  }, [_c('span', {
    staticClass: "alt-text"
  }, [_vm._v(_vm._s(_vm.siteName))])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "menu horizontal"
  }, _vm._l((_vm.menu), function(item, index) {
    return _c('li', {
      class: 'item-' + index,
      on: {
        "click": function($event) {
          _vm.listen(item)
        }
      }
    }, [_c('router-link', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  })), _vm._v(" "), (_vm.isProjectPage) ? _c('div', {
    staticClass: "project-arrow icon-triangle-next",
    on: {
      "click": function($event) {
        _vm.showNext()
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "menu-toggle icon-hamburger",
    on: {
      "click": function($event) {
        _vm.menuToggle()
      }
    }
  }, [_c('span', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.menu_toggle_label))])])]), _vm._v(" "), _c('keep-alive', [_c('router-view')], 1), _vm._v(" "), _c('footer', {
    attrs: {
      "id": "footer"
    }
  }, [_c('ul', {
    staticClass: "bottom-list horizontal menu"
  }, [_c('li', {
    staticClass: "copyright",
    on: {
      "click": function($event) {
        _vm.clearCaches()
      }
    }
  }, [_vm._v(_vm._s(_vm.footer.copyright))]), _vm._v(" "), _vm._l((_vm.footer.menu), function(item) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": item.link
      }
    }, [_vm._v(_vm._s(item.title))])], 1)
  }), _vm._v(" "), (_vm.footer.email.length > 5) ? _c('li', {
    staticClass: "email"
  }, [_c('a', {
    attrs: {
      "href": 'mailto:' + _vm.footer.email
    }
  }, [_vm._v(_vm._s(_vm.footer.email))])]) : _vm._e()], 2), _vm._v(" "), (_vm.statusMsg.length > 1) ? _c('div', {
    staticClass: "status-msg",
    class: {
      'show': _vm.showStatusMsg
    }
  }, [_vm._v(_vm._s(_vm.statusMsg))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "loader"
  }), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    attrs: {
      "id": "admin-bar"
    }
  }, [(_vm.currId > 0) ? _c('span', {
    on: {
      "click": function($event) {
        _vm.showAdminOverlay()
      },
      "dblclick": function($event) {
        _vm.showAdminPage()
      }
    }
  }, [_vm._v("Edit")]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "overlay-container",
    class: {
      'show-admin': _vm.showAdmin
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAdmin),
      expression: "showAdmin"
    }],
    staticClass: "close",
    on: {
      "click": function($event) {
        _vm.hideAdminOverlay()
      }
    }
  }, [_vm._v("x")]), _vm._v(" "), _c('iframe', {
    attrs: {
      "src": _vm.adminUrl,
      "id": "admin-frame",
      "name": "admin-frame"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3fd3295a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 44
// module chunks = 0